// extracted by mini-css-extract-plugin
module.exports = {"modalForm":"AddWarehousemanModal_modalForm__2MfHd"};